<template>
  <div v-if="shouldShow">
    <!-- Warning Banner (no longer collapsible) -->
    <v-col v-if="showBanner" cols="12" class="pa-0 mt-3">
      <div
        style="
          background-color: var(--asu-warning-yellow-light);
          color: #191919;
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 16px;
        "
      >
        <v-icon color="#191919" size="24" class="fas fa-exclamation-triangle" />
        <span class="font-weight-bold" style="font-size: 14px">
          {{ message }}
        </span>
      </div>
    </v-col>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PartnershipWarning',

  props: {
    /**
     * Warning configuration from the API
     * Expected shape: { showPartnershipWarning: boolean, partnershipWarningMessage: string }
     */
    warning: {
      type: Object,
      default: null
    },

    /**
     * Whether to show the warning banner
     */
    showBanner: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    /**
     * Check if warning should be displayed
     */
    shouldShow() {
      return this.warning?.showPartnershipWarning === true;
    },

    /**
     * Get the warning message from the API
     */
    message() {
      return this.warning?.partnershipWarningMessage || '';
    }
  }
});
</script>
